import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetPaymentTradesRequestModel, GetPaymentTradesResponseModel } from "@/features/accounts/payment/scraping/services/get-trades-model";

export class GetPaymentTradesApi {
  /**
   * Look明細取得API
   */
  public getPaymentTrades = async (
    param: GetPaymentTradesRequestModel
  ): Promise<GetPaymentTradesResponseModel[]> => {
    const path = `/api/paymentaccounts/payments/trades`;
    const res = await ApiClient.instance.get<GetPaymentTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
